import React, { useState, useEffect } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";
import Loader from "../../../components/Loader";
import SidebarFilter from "../../../components/SidebarFilter";
import { useSelector, userActions, tagsActions, contingentsActions } from "inbooma-api";
import { Biscuit, getAllUrlParams } from "../../../../utils";
import { $, _, moment } from "../../../../../vendor";
import SidebarMenu from "./SidebarMenu";
import { getEnvPrefix } from "../../../../utils/Uri";
import { getApiHost } from "../../../../Sync";
import * as FileSaver from "../../../../../vendor/FileSaver";
import TagList from "../../../components/TagList";
import LargeButton from "../../../components/LargeButton";
import InboomaSelectBox from "../../../components/InboomaSelectBox";
import { getDocHandler, getFilterData } from "../../../../utils/Helper";
import Paginator from "../../../components/paginator";
import showNotification from "../../../helpers/showNotification";
import SDFDialog from "./behaviors/SDFDialog";

const OrdersSidebar = (props) => {
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  allUrlParams?.fullname !== undefined && delete allUrlParams.fullname;
  allUrlParams?.type !== undefined && delete allUrlParams.type;
  allUrlParams?.paystate !== undefined && delete allUrlParams.paystate;
  let language = Biscuit.get("user.lang").replace("-", "_");

  const [ready, setReady] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(props.filter); // default values?

  const [users, setUsers] = useState([]);

  const _users = useSelector((state) => state.users_data.users);
  const [showSDFDialog, setShowSDFDialog] = useState(false);
  const [usersPending, setUsersPending] = useState(false);
  const cleanState = { mainFilter: false, userIdFilter: false, tagFilter: false };
  const [usedFilterCount, setUsedFilterCount] = useState({
    mainFilter: allUrlParams?.status !== undefined ? true : false,
    userIdFilter: allUrlParams?.user_id !== undefined ? true : false,
    tagFilter: allUrlParams?.tags !== undefined ? true : false,
  });
  const [statusFilter, setStatusFilter] = useState({
    value: searchParams.get("status") !== null ? searchParams.get("status") : "all",
  }); // 'all', 'active', 'inactive'
  const [filterCount, setFilterCount] = useState(
    Object.keys(allUrlParams).length > 0 ? Object.keys(allUrlParams).length : 0,
  );
  const [selectedUser, setSelectedUser] = useState(
    searchParams.get("fullname") !== null && searchParams.get("user_id") !== null
      ? { value: searchParams.get("user_id"), label: searchParams.get("fullname") }
      : null,
  );
  const _tags = useSelector((state) => state.tags_data.getTagCloud);
  const [tags, setTags] = useState([]);
  const [tagsPending, setTagsPending] = useState(false);
  const [tagSetted, setTagSetted] = useState(searchParams.get("tags") !== null ? true : false);
  const [_resetFilter, _setResetFilter] = useState(props.resetFilter);
  const [selectedDateFrom, setSelectedDateFrom] = useState(
    searchParams.get("date_from") !== null
      ? moment(searchParams.get("date_from"), "YYYY-MM-DD").toDate()
      : null,
  );
  const [selectedDateTo, setSelectedDateTo] = useState(
    searchParams.get("date_to") !== null
      ? moment(searchParams.get("date_to"), "YYYY-MM-DD").toDate()
      : null,
  );

  const [selectedItems, setSelectedItems] = useState(
    searchParams.get("fullname") !== null && searchParams.get("user_id") !== null
      ? [{ id: searchParams.get("user_id"), name: searchParams.get("fullname") }]
      : [{}],
  );
  const [selectedPaystate, setSelectedPaystate] = useState(
    searchParams.get("paystate") !== null && searchParams.get("paystate") !== null
      ? { id: searchParams.get("paystate"), name: searchParams.get("paystate_name") }
      : null,
  );
  const onSelectItem = (item) => {
    let items = [...selectedItems];
    items.push(item);
    setSelectedItems(items);
  };
  const addOrderUrl = `orders/add${currentUrl.search}`;
  // default: nothing selected

  /**
   * can be generally defined in common sidebar
   * @param {event} ev
   */
  const onToggleLeftBar = (ev) => {
    $("#inb-c-sidebar").toggleClass("open");
    $("html,body").scrollTop(0);
  };

  const addOrderHandler = (value) => {};

  // method can be used to proof if filter combination is valid
  const onUserSelectHandle = (item, fetch = true) => {
    // should validate filter combination and start request
    var clone = { ...globalFilter };
    var clone2 = { ...usedFilterCount };
    console.log(item);
    if (item === null || typeof item.id === "undefined" || item.id === null) {
      delete clone.user_id;
      clone2.userIdFilter = false;
      setSelectedUser(null);
      setSelectedItems([]);
      searchParams.delete("user_id");
      searchParams.delete("fullname");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      const user = { label: item.name, value: item.id };
      clone.user_id = item.id;
      clone2.userIdFilter = true;
      setSelectedUser(user);
      setSelectedItems(user);
      searchParams.set("user_id", user.value);
      searchParams.set("fullname", user.label);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
    setUsedFilterCount(clone2);
    setGlobalFilter(clone);
    onFilterCountChangeHandle(clone2);
    // fetch wallet transactions
    if (fetch) {
      props.filterChangedHandle(clone);
    }
  };

  const onLocationQueryHandle = (query) => {
    // start dispatch of location query
    props.dispatch(
      locationActions.getLocations({
        token: Biscuit.get("token"),
        filter: {
          findForSelect: true,
          find: "short",
          limit: 999,
          page: 1,
          q: query,
        },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
  };

  const onFilterCountChangeHandle = (value) => {
    var clone = { ...value };
    var count = 0;
    for (const [type, val] of Object.entries(clone)) {
      if (val) {
        count++;
      }
    }
    if (count < 1) {
      count = 0;
      $("#inb-selected-filters").addClass("hidden");
    } else {
      $("#inb-selected-filters").removeClass("hidden");
    }
    setFilterCount(count);
  };
  /* const onQuickFilterSelectHandle = (value) => {
        console.log("quick filter: ",value);
        // remove all date filter
        var clone = {...globalFilter};
        switch (value) {
            case 'previous_year':
                const prevYear = Number(moment().format('YYYY'))-1;
                clone.end_lte = prevYear + "-12-31%2023:59:59";
                clone.begin_gte = prevYear + "-01-01%2000:00:00";
                break;
            case 'current_day':
                const day = moment().format('DD');
                clone.end_lte = moment().format('YYYY-MM-DD HH:mm:ss');
                clone.begin_gte = moment().format('YYYY-MM') + '-' + day + '%2000:00:00';
                break;
            case 'previous_day':
                const prevDay = Number(moment().format('DD'))-1;
                clone.end_lte = moment().format('YYYY-MM') + '-' + prevDay + '%2023:59:59';
                clone.begin_gte = moment().format('YYYY-MM') + '-' + prevDay + '%2000:00:00';
                break;
            case '':
            default:
                delete clone.end_lte;
                delete clone.begin_gte;
        }
        setGlobalFilter(clone);
        // reset datepickers
        if (selectedDateFrom !== null) setSelectedDateFrom(null);
        if (selectedDateTo !== null) setSelectedDateTo(null);
        // reset month filter
        setSelectedMonthfilter("");
        setSelectedQuickfilter(value);
        props.filterChangedHandle(clone);
    };*/

  const dateKeyDownHandle = (e) => {
    console.log("key down date: ", e);
  };

  const onStatusSelectHandle = (status, fetch = true) => {
    setStatusFilter({ value: status });
    // should vaildate filter combo
    var clone = { ...globalFilter };
    var clone2 = { ...usedFilterCount };
    /* if (status === 'cancelled') {
            if (typeof clone.finder !== 'undefined') {
                delete clone.finder;
            }
        } else {
            if (typeof clone.finder === 'undefined') {
                clone = {...clone,finder: 'NotCancelled'};
            }
        }*/
    if (status === "all" || status === null) {
      delete clone.status;
      clone2.mainFilter = false;
      searchParams.delete("status");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      clone.status = status;
      clone2.mainFilter = true;
      searchParams.set("status", status);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
    setGlobalFilter(clone);
    setUsedFilterCount(clone2);
    onFilterCountChangeHandle(clone2);
    if (fetch) {
      props.filterChangedHandle(clone);
    }
  };
  /*const getUserDisplayName = (user_id) => {

        return user.first_name + ' ' + user.last_name;
    };*/

  useEffect(() => {
    if (_users.success === "" || !usersPending) return;

    if (_users.success === true) {
      if (_users.data.length) {
        let userArray = [];
        _users.data.map((user) => {
          userArray.push({ value: user.id, label: user.last_name + ", " + user.first_name });
        });
        setUsers(userArray);
      }
    } else if (_users.success === false) {
      console.log("Failed to request users!");
    }
    setUsersPending(false);
    if (tagsPending === false) setReady(true);
  }, [_users]);

  useEffect(() => {
    if (_tags.success === "" || !tagsPending) return;

    if (_tags.success === true) {
      // compute name attribute '_name'
      var clone = [..._tags.data];
      setTags(clone);
    } else if (_tags.success === false) {
      console.log("Failed to request tag-cloud!");
    }
    setTagsPending(false);
    if (usersPending === false) setReady(true);
  }, [_tags]);

  useEffect(() => {
    if (!_resetFilter) return;

    if (_resetFilter) {
      resetFilter();
    }
    _setResetFilter(false);
  }, [_resetFilter]);

  const initialize = () => {
    if (ready) return;

    if (usersPending || tagsPending) return;
    // get locations and users to filter for
    props.dispatch(
      userActions.getUsers({
        token: Biscuit.get("token"),
        filter: {
          findForSelect: true,
          find: "short",
          limit: 999,
          page: 1,
        },
      }),
    );
    setUsersPending(true);

    props.dispatch(
      tagsActions.getTagCloud({
        token: Biscuit.get("token"),
        filter: {
          namespace: "Orders",
        },
        suffix: "",
        parameters: {
          headers: {
            "Accept-Language": language,
          },
        },
      }),
    );
    setTagsPending(true);
  };

  if (!ready) initialize();

  const updateTagList = () => {
    var fakeTagBox,
      tagBox = document.getElementById("inb-c-left-bar-flist--tag");
    for (var i = 0; i < tagBox.childNodes.length; i++) {
      if (tagBox.childNodes[i].tagName == "LI") {
        tagBox.removeChild(tagBox.childNodes[i]);
        i--;
      } else if (tagBox.childNodes[i].tagName == "UL") {
        fakeTagBox = tagBox.childNodes[i];
        fakeTagBox.innerHTML = "";
      }
    }
    // set hidden tags and fake tags
    for (var u = 0; i < tags.length; i++) {
      // hidden tags
      var tag = document.createElement("li");
      var content = document.createElement("a");
      content.innerHTML = tags[u].label;
      content.setAttribute("href", "#");
      content.setAttribute("class", "order-sidebar-tag-link");
      tag.setAttribute("class", "hide");
      tag.setAttribute("data-counter", tags[u].counter);
      tag.setAttribute("data-inb-val", tags[u].label);
      tag.setAttribute("title", t("filter_tag_${a}", { a: tags[u].label }));
      tag.appendChild(content);
      tagBox.appendChild(tag);

      // fake tags
      if (fakeTagBox === undefined) continue;
      var fakeTag = document.createElement("li");
      var fakeContent = document.createElement("a");
      fakeContent.innerHTML = tags[u].label;
      fakeContent.setAttribute("href", "#");
      fakeTag.setAttribute("class", "inb-fake-tag");
      fakeTag.setAttribute("data-counter", tags[u].counter);
      fakeTag.setAttribute("data-inb-val", tags[u].label);
      fakeTag.setAttribute("title", t("filter_tag_${a}", { a: tags[u].label }));
      fakeTag.appendChild(fakeContent);
      fakeTagBox.appendChild(fakeTag);
    }
  };

  const ClickHandler = (value) => {
    if (value === "export-xls") {
      _export();
    } else if (value === "export-sdf") {
      _exportSDF();
    }
  };

  const onTagClicked = (tag) => {
    // should vaildate filter combo
    var clone = { ...globalFilter };
    var clone2 = { ...usedFilterCount };
    if (typeof tag === "undefined" || tag === null) {
      delete clone.tags;
      clone2.tagFilter = false;
      setTagSetted(false);
      searchParams.delete("tags");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      clone.tags = tag;
      clone2.tagFilter = true;
      setTagSetted(true);
      searchParams.set("tags", tag);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
    setGlobalFilter(clone);
    setUsedFilterCount(clone2);
    onFilterCountChangeHandle(clone2);
    // fetch reservations
    if (fetch) {
      props.filterChangedHandle(clone);
    }
  };

  const getMenu = () => {
    const host = getEnvPrefix();
    let menu = [
      /*{
                text: t('help',null,'capital'),
                href: "/reservationsList/help",
                iconClass: "ico-inb inb-fi-help",
                title: "help-link",
                handler: ClickHandler,
                id: 'help'
            },
           {
               spacer: true
           },*/
      {
        text: t("export_xls", null, "capital"),
        href: "#",
        iconClass: "ico-inb inb-fi-excel",
        rel: "noopener noreferrer",
        title: "export-xls",
        id: "export-xls",
        handler: ClickHandler,
      },
    ];
    if (Biscuit.get("user.role") != "user" && Biscuit.get("client.canExportSDF") === "true") {
      menu.push({
        text: t("export_sdf", null, "capital"),
        href: "#",
        iconClass: "ico-inb inb-fi-excel",
        title: "export-sdf",
        id: "export-sdf",
        handler: ClickHandler,
      });
    }
    menu.push({
      spacer: true,
    });
    if (Biscuit.get("user.role") != "user" && Biscuit.get("client.isVehicleOwner") === "true") {
      menu.push({
        text: t("daily_rental_contract", null, "capital"),
        href: "/orders/export",
        iconClass: "ico-inb inb-fi-pdf",
        title: "export-pdf",
        id: "export-pdf",
        handler: ClickHandler,
      });
    }
    if (
      Biscuit.get("client.isVehicleOwner") === "true" ||
      Biscuit.get("client.isBikeSharing") === "true" ||
      Biscuit.get("client.hasParkingLots") === "true"
    ) {
      menu.push({
        spacer: true,
      });
      menu.push({
        text: t("schedule", null, "capital"),
        href: "https://" + host + "cal.inbooma.net?hash=" + Biscuit.get("client.hash"),
        target: "_blank",
        rel: "noopener noreferrer",
        iconClass: "ico-inb inb-fi-calendar",
        title: "schedule",
        id: "schedule",
        handler: ClickHandler,
      });
    }
    if (Biscuit.get("user.client_id") == 7) {
      menu.push({
        spacer: true,
      });
      menu.push({
        text: t("schedule_heart_route", null, "capital"),
        href:
          "https://" +
          host +
          "cal.inbooma.net?hash=" +
          Biscuit.get("client.hash") +
          "&network=herzroute",
        target: "_blank",
        rel: "noopener noreferrer",
        iconClass: "ico-inb inb-fi-calendar",
        title: "schedule_heart_route",
        id: "schedule_heart_route",
        handler: ClickHandler,
      });
    }
    if (Biscuit.get("user.role") !== "user" && Biscuit.get("client.isVehicleOwner") === "true") {
      menu.push({
        spacer: true,
      });
      menu.push({
        text: t("list deliveries", null, "capital"),
        href: "/orders/groupList",
        target: "_blank",
        rel: "noopener noreferrer",
        iconClass: "ico-inb inb-fi-excel",
        title: "list deliveries",
        id: "list_deliveries",
        handler: ClickHandler,
      });
    }
    return menu;
  };

  const _export = () => {
    let params = "",
      count = 0,
      begin = null,
      end = null;
    var clone = { ...globalFilter };
    for (const [type, val] of Object.entries(clone)) {
      if (count > 0) {
        params += "&" + type + "=" + val;
      } else {
        params += "?" + type + "=" + val;
      }
      count++;
    }
    const xmlHttp = new XMLHttpRequest();

    xmlHttp.open("GET", getApiHost() + "/orders/export" + params, true);

    //  xmlHttp.setRequestHeader('Accept', 'application/json')
    xmlHttp.setRequestHeader("Authorization", "Bearer " + Biscuit.get("token"));
    xmlHttp.setRequestHeader("Content-Language", language);
    xmlHttp.setRequestHeader("Accept-Language", language);
    xmlHttp.responseType = "blob";

    xmlHttp.onload = function () {
      const blob = new Blob([xmlHttp.response], { type: "application/xls" });
      FileSaver.saveAs(blob, t("orders") + " " + get_date() + ".xlsx");
    };

    xmlHttp.send(null);
  };

  const _exportSDF = () => {
    setShowSDFDialog(true);
  };

  const selectedDateToHandle = (date, fetch = true) => {
    searchParams.get("initial") !== null && searchParams.delete("initial");
    let clone = { ...globalFilter };
    let clone2 = { ...usedFilterCount };
    if (date === null) {
      if (typeof clone.created_gte !== "undefined") {
        delete clone.created_gte;
      }
      clone2.dateToFilter = false;
      searchParams.delete("created_lte");
      searchParams.delete("date_to");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      clone.created_lte = moment(date).format("YYYY-MM-DD") + "%2023:59:59";
      clone2.dateToFilter = true;
      clone2.mainFilter = false;

      searchParams.set("created_lte", moment(date).format("YYYY-MM-DD"));
      searchParams.set("date_to", moment(date).format("YYYY-MM-DD"));
      searchParams.set("sort", "created");
      searchParams.set("direction", clone2.dateFromFilter ? "asc" : "desc");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
    setGlobalFilter(clone);
    setUsedFilterCount(clone2);
    setSelectedDateTo(date);
    onFilterCountChangeHandle(clone2);
    // reset month and quick filter
    if (fetch) {
      props.filterChangedHandle(clone);
    }
  };

  const selectedDateFromHandle = (date, fetch = true) => {
    searchParams.get("initial") !== null && searchParams.delete("initial");
    let clone = { ...globalFilter };
    let clone2 = { ...usedFilterCount };
    if (date === null) {
      if (typeof clone.created_gte !== "undefined") {
        delete clone.created_gte;
      }
      clone2.dateFromFilter = false;

      searchParams.delete("created_gte");
      searchParams.delete("sort");
      searchParams.delete("direction");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      clone.created_gte = moment(date).format("YYYY-MM-DD") + "%2000:00:00";
      clone2.dateFromFilter = true;
      clone2.mainFilter = false;
      searchParams.set("created_gte", moment(date).format("YYYY-MM-DD"));
      searchParams.set("date_from", moment(date).format("YYYY-MM-DD"));
      searchParams.set("sort", "created");
      searchParams.set("direction", "asc");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
    setGlobalFilter(clone);
    setUsedFilterCount(clone2);
    setSelectedDateFrom(date);
    onFilterCountChangeHandle(clone2);
    // reset month and quick filter
    if (fetch) {
      props.filterChangedHandle(clone);
    }
  };
  const get_date = (date = null) => {
    let today = new Date();
    if (date !== null) {
      today = new Date(date);
    }
    let day = today.getDate(); // Tag

    // Monatsangabe startet bei 0!
    let month = today.getMonth() + 1; // Monat

    let year = today.getFullYear(); // Jahr
    if (day < 10) {
      day = "0" + day;
    }
    if (month < 10) {
      month = "0" + month;
    }
    today = day + "." + month + "." + year;

    return today;
  };

  const onUserQueryHandle = (query) => {
    // start dispatch of user query
    props.dispatch(
      userActions.getUsers({
        token: Biscuit.get("token"),
        filter: {
          findForSelect: true,
          find: "short",
          limit: 999,
          page: 1,
          n: query,
        },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setUsersPending(true);
  };
  const onTagRemoved = (e) => {
    var clone = { ...globalFilter };
    var clone2 = { ...usedFilterCount };
    delete clone.tags;
    clone2.tagFilter = false;
    setTagSetted(false);
    setGlobalFilter(clone);
    setUsedFilterCount(clone2);
    onFilterCountChangeHandle(clone2);
    props.filterChangedHandle(clone);
    searchParams.delete("tags");
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
  };

  const onPaystateSelectHandle = (paystateId, paystateName, fetch = true) => {
    const paystate = { name: paystateName, id: paystateId };
    console.log("paystate selected: ", paystate);

    // should validate filter combination and start request

    let clone = { ...globalFilter };
    let clone2 = { ...usedFilterCount };
    if (typeof paystateId === "undefined" || paystateId === null) {
      delete clone.paystate;
      clone2.paystateFilter = false;
      setSelectedPaystate(null);
      searchParams.delete("paystate");
      searchParams.delete("paystate_name");
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    } else {
      clone.paystate = paystateId;
      clone2.paystateFilter = true;
      setSelectedPaystate(paystate);
      searchParams.set("paystate", paystate.id);
      searchParams.set("paystate_name", paystate.name);
      const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
      history.pushState(null, "", newRelativePathQuery);
    }
    setUsedFilterCount(clone2);
    setGlobalFilter(clone);
    onFilterCountChangeHandle(clone2);
    // fetch wallet transactions
    if (fetch) {
      props.filterChangedHandle(clone);
    }
  };

  const handleCloseDialog = () => {
    setShowSDFDialog(false);
  };
  const resetFilter = (e) => {
    selectedDateFromHandle(null, false);
    selectedDateToHandle(null, false);
    var clone = {
      find: "full",
    };
    setUsedFilterCount(cleanState);
    setSelectedUser(null);
    setStatusFilter("all");
    setTagSetted(false);
    setFilterCount(0);
    setGlobalFilter(clone);
    onFilterCountChangeHandle(cleanState);
    props.setMainFilter(clone);
    props.filterChangedHandle(clone);
    setReady(false);
    initialize();
    const newRelativePathQuery = window.location.pathname + "?type=orders";
    history.pushState(null, "", newRelativePathQuery);
  };

  return (
    <>
      <aside id="inb-c-sidebar" className="filemanager-sidebar" style={{ float: "left" }}>
        <header className="inb-c-left-bar__title sticky-top">
          <h1 className="inb-page-title">{props.heading}</h1>
          <SidebarMenu menu={getMenu()} />
        </header>

        {!ready && <Loader mediumWidth={4} smallWidth={4} subLoaders={2} />}
        {ready && (
          <>
            <div className="sticky-top-filter">
              <aside id="inb-selected-filters">
                {filterCount > 0 && (
                  <ul>
                    <p>
                      <i className="fi fi-filter"> </i>
                      <span id="inb-selected-filters__count">{" " + filterCount}</span>

                      {" " + t("filter_selected")}
                      <a
                        href="#"
                        id="inb-selected-filters__unset"
                        className="unset-filter"
                        title={t("unselect_all_filter")}
                        onClick={(e) => {
                          resetFilter(e);
                        }}
                      >
                        x
                      </a>
                    </p>
                  </ul>
                )}
              </aside>

              {
                <SidebarFilter
                  id="inb-c-left-bar-flist--orders-status"
                  heading={t("status")}
                  type="list"
                  data={getFilterData(
                    [
                      { name: t("all"), value: "all" },
                      { name: t("requested", null, "capital"), value: "requested" },
                      { name: t("confirmed"), value: "confirmed" },
                      { name: t("authorized", null, "capital"), value: "authorized" },
                      { name: t("pending", null, "capital"), value: "pending" },
                      { name: t("cancelled"), value: "cancelled" },
                      { name: t("paid"), value: "paid" },
                    ],
                    props.summaryPending,
                    props.summary,
                  )}
                  dataKey="value"
                  selected={statusFilter.value}
                  summaryPending={props.summaryPending}
                  onChangeHandle={onStatusSelectHandle}
                />
              }
              <SidebarFilter
                id="inb-c-left-bar-flist--reservations-paystate"
                heading={t("paystate")}
                type="select2"
                data={[
                  {
                    id: "unpaid",
                    name: t("unpaid"),
                  },
                  {
                    id: "paid",
                    name: t("paid"),
                  },
                  {
                    id: "refund",
                    name: t("refunded"),
                  },
                ]}
                dataKey="id"
                nameAttribute="name"
                onChangeHandle={onPaystateSelectHandle}
                value={selectedPaystate !== null ? selectedPaystate : null}
                placeholder={"- " + t("all", null, "capital") + " -"}
                //selected={selectedBeginLocation}
              />
              <SidebarFilter
                id="inb-c-left-bar-flist--reservations-date"
                heading={t("order created", null, "capital")} // t('timespan', null, 'capital')+" "+
                type="datePicker"
                data={[
                  {
                    name: "date_from",
                    className: "noBorders-noBackground",
                    dateFormat: "dd.MM.y",
                    selected: selectedDateFrom,
                    onChangeHandle: selectedDateFromHandle,
                    onKeyDownHandle: dateKeyDownHandle,
                    placeholder: t("valid_from", null, "capital") + " ...",
                    extraClassName: "order_from",
                  },
                  {
                    name: "date_to",
                    className: "noBorders-noBackground",
                    dateFormat: "dd.MM.y",
                    selected: selectedDateTo,
                    onChangeHandle: selectedDateToHandle,
                    onKeyDownHandle: dateKeyDownHandle,
                    placeholder: " ..." + t("valid_to", null, "capital"),
                    extraClassName: "order_to",
                  },
                ]}
              />
              {/*<SidebarFilter
                        id="inb-c-left-bar-flist--orders-status"
                        heading={t('status')}
                        type="list"
                        data={[{
                            name: t('all', null, 'capital'), value: 'all'
                        }, {
                            name: t('requested', null, 'capital'), value: 'requested'
                        }, {
                            name: t('confirmed', null, 'capital'), value: 'confirmed'
                        }, {
                            name: t('authorized', null, 'capital'), value: 'authorized'
                        }, {
                            name: t('pending', null, 'capital'), value: 'pending'
                        }, {
                            name: t('cancelled', null, 'capital'), value: 'cancelled'
                        }, {
                            name: t('paid', null, 'capital'), value: 'paid'
                        }
                        ]}
                        dataKey="value"
                        selected={typeof statusFilter.value !== 'undefined' && statusFilter.value !== null ? statusFilter.value : undefined}
                        onChangeHandle={onStatusSelectHandle}/>*/}
              {ready && rbac.hasPermission("edit") && (
                <>
                  <SidebarFilter
                    id="inb-c-left-bar-flist--orders-users"
                    heading={t("user")}
                    type="InboomaSelect"
                    sortBy="created"
                    sortDirection="desc"
                    placeholder={"- " + t("all", null, "capital") + " -"}
                    selectedItems={selectedItems}
                    setSelectedItems={setSelectedItems}
                    onSelectHandle={onUserSelectHandle}
                    dispatch={props.dispatch}
                    multiSelect={false}
                    advanced={true}
                    extraStyle={{ width: "700px" }}
                  />
                </>
              )}
              {ready && rbac.hasPermission("edit") && (
                <>
                  <TagList
                    onTagClicked={onTagClicked}
                    updateTagList={updateTagList}
                    tags={tags}
                    onFilterRemoveHandle={onTagRemoved}
                    tagSetted={tagSetted}
                  />
                </>
              )}
            </div>
          </>
        )}
        {rbac.hasPermission("edit") && (
          <>
            <footer className="inb-c-left-bar__footer small-only-float-container center-on-content">
              <a
                href="#"
                id="toggle-left-bar"
                className="button secondary show-for-small-only"
                onClick={(e) => onToggleLeftBar(e)}
              >
                <i className="fi fi-filter"> </i>
                <span className="show-for-sr">{t("open_filter_menu")}</span>
              </a>
              <LargeButton
                link={addOrderUrl}
                beautify={true}
                icon="fi fi-page-add"
                title={t("add_${a}", { a: t("order") })}
                name="add-orders"
                handler={addOrderHandler}
              />
            </footer>
          </>
        )}
      </aside>
      {showSDFDialog && (
        <SDFDialog
          handleCloseDialog={handleCloseDialog}
          dispatch={props.dispatch}
          language={props.language}
          showNotification={props.showNotification}
        />
      )}
    </>
  );
};

export default OrdersSidebar;
